import type { Study } from './study.interface';

export enum SexEnum {
  Male,
  Female
}

export enum SterilisationEnum {
  Sterilized,
  NotSterilized
}

export interface PatientInterface {
  id: number;
  petName: string;
  ownerName: string;
  fullname?: string;
  sexe: string;
  speciesName: string;
  birthDate?: string | Date | undefined;
  pid:  string;
  speciesId: number;
  sterilisationStatus: string;
  studies?: Study[];
}
